<template>
  <div :class="classes">
    <div :class="[prefixCls + '-header']">
            <span v-for="day in headerDays" :key="day">
                {{day}}
            </span>
    </div>
    <span
      :class="getCellCls(cell)"
      v-for="(cell, i) in cells"
      :key="String(cell.date) + i"
      @click="handleClick(cell, $event)"
      @mouseenter="handleMouseMove(cell)"
    >
            <em>{{ cell.desc }}</em>
        </span>
  </div>
</template>
<script>
  import {clearHours, isInRange} from '../util';
  import Locale from 'view-design/src/mixins/locale';
  import jsCalendar from 'js-calendar';

  import mixin from './mixin';
  import prefixCls from './prefixCls';


  export default {
    mixins: [Locale, mixin],

    props: {
      /* more props in mixin */
      showWeekNumbers: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        prefixCls: prefixCls,
      };
    },
    computed: {
      classes() {
        return [
          `${prefixCls}`,
          {
            [`${prefixCls}-show-week-numbers`]: this.showWeekNumbers
          }
        ];
      },
      calendar() {
        const weekStartDay = Number(this.t('i.datepicker.weekStartDay'));
        return new jsCalendar.Generator({onlyDays: !this.showWeekNumbers, weekStart: weekStartDay});
      },
      headerDays() {
        const weekStartDay = Number(this.t('i.datepicker.weekStartDay'));
        const translatedDays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].map(item => {
          return this.t('i.datepicker.weeks.' + item);
        });
        const weekDays = translatedDays.splice(weekStartDay, 7 - weekStartDay).concat(translatedDays.splice(0, weekStartDay));
        return this.showWeekNumbers ? [''].concat(weekDays) : weekDays;
      },
      cells() {
        const tableYear = this.tableDate.getFullYear();
        const tableMonth = this.tableDate.getMonth();
        const today = clearHours(new Date());    // timestamp of today
        const selectedDays = this.dates.filter(Boolean).map(clearHours);    // timestamp of selected days
        const [minDay, maxDay] = this.dates.map(clearHours);
        const [oldMinDay, oldMaxDay] = this.isCompared ? this.publicStringValue.map(clearHours) : [null, null];
        const rangeStart = this.rangeState.from && clearHours(this.rangeState.from);
        const rangeEnd = this.rangeState.to && clearHours(this.rangeState.to);
        const comparedStart = this.comparedRange.from && clearHours(this.comparedRange.from);
        const comparedEnd = this.comparedRange.to && clearHours(this.comparedRange.to);

        const isRange = this.selectionMode === 'range';
        const disabledTestFn = typeof this.disabledDate === 'function' && this.disabledDate;

        return this.calendar(tableYear, tableMonth, (cell) => {
          // normalize date offset from the dates provided by jsCalendar
          if (cell.date instanceof Date) cell.date.setTime(cell.date.getTime() + cell.date.getTimezoneOffset() * 60000);

          const time = cell.date && clearHours(cell.date);
          const dateIsInCurrentMonth = cell.date && tableMonth === cell.date.getMonth();
          return {
            ...cell,
            type: time === today ? 'today' : cell.type,
            selected: dateIsInCurrentMonth && selectedDays.includes(time),
            disabled: (cell.date && disabledTestFn) && disabledTestFn(new Date(time)),
            range: dateIsInCurrentMonth && isRange && isInRange(time, rangeStart, rangeEnd),
            comparedRange: dateIsInCurrentMonth && isRange && isInRange(time, comparedStart, comparedEnd),
            oldStart: dateIsInCurrentMonth && isRange && time === oldMinDay,
            oldEnd: dateIsInCurrentMonth && isRange && time === oldMaxDay,
            start: dateIsInCurrentMonth && isRange && time === minDay,
            end: dateIsInCurrentMonth && isRange && time === maxDay
          };
        }).cells.slice(this.showWeekNumbers ? 8 : 0);
      }
    },
    methods: {
      getCellCls(cell) {
        const isCompared = this.isCompared;
        return [
          `${prefixCls}-cell`,
          {
            [`${prefixCls}-cell-selected`]: cell.selected || cell.start || cell.end,
            [`${prefixCls}-cell-selected-base`]: isCompared ? (cell.oldStart || cell.oldEnd) : (cell.start || cell.end),
            [`${prefixCls}-cell-selected-compared`]: isCompared && (cell.start || cell.end),
            [`${prefixCls}-cell-disabled`]: cell.disabled,
            [`${prefixCls}-cell-today`]: cell.type === 'today',
            [`${prefixCls}-cell-prev-month`]: cell.type === 'prevMonth',
            [`${prefixCls}-cell-next-month`]: cell.type === 'nextMonth',
            [`${prefixCls}-cell-week-label`]: cell.type === 'weekLabel',
            [`${prefixCls}-cell-range`]: cell.range && !cell.start && !cell.end && !cell.oldStart && !cell.oldEnd,
            [`${prefixCls}-cell-range ${prefixCls}-cell-range-compared`]: isCompared && (cell.comparedRange && !cell.start && !cell.end),
            [`${prefixCls}-focused`]: clearHours(cell.date) === clearHours(this.focusedDate)

          }
        ];
      },

    }
  };
</script>
<style scoped>
  .ivu-date-picker-cells-cell-selected-base em, .ivu-date-picker-cells-cell-selected-base:hover em {
    background: #0084FF;
    color: #fff;
  }

  .ivu-date-picker-cells-cell-selected-compared em, .ivu-date-picker-cells-cell-selected-compared:hover em {
    background: #10BC80 !important;
  }

  .ivu-date-picker-cells-cell-range-compared:before {
    background: #eafaf4 !important;
  }

  .ivu-date-picker-cells-cell-range-compared:hover em {
    background: #eafaf4 !important;
  }

  .compared-text-title {
    transform: scale(.8);
    transform-origin: left;
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// src/views/my-components/custom-date-picker/base/date-table.vue